import { useResponsive } from '@ui/style/useResponsive';
import { spaceAboveHeader } from '@ui/style/variables';
import { useAppSelector } from '@application/store/useStore';
const useLayoutStyles = () => {
    const { isMobileIpadNavigation } = useResponsive();
    // Check if selected company is VDK groep
    const { selectedCompanyId, companies } = useAppSelector((state) => state.company);
    const selectedCompany = companies.find((c) => selectedCompanyId.includes(c.id));
    // When multiple companies are selected, use VDK Groep theme
    const isMultipleCompaniesSelected = selectedCompanyId.length > 1;
    const isVDKGroep = isMultipleCompaniesSelected ||
        selectedCompany?.name?.toLowerCase().includes('vdk groep') ||
        selectedCompany?.name?.toLowerCase().includes('vdkgroep') ||
        selectedCompany?.name?.toLowerCase() === 'vdk groep';
    const companyTheme = useAppSelector((state) => state.companyTheme.currentTheme);
    // Check if company has no customizations at all
    const hasNoCustomizations = !companyTheme?.primaryColor && !companyTheme?.secondaryColor && !companyTheme?.fontFamily;
    // Apply VDK gradient if: VDK groep OR no customizations at all
    const shouldApplyVDKGradient = isVDKGroep || hasNoCustomizations;
    return {
        layoutMainContainer: {
            minHeight: '100dvh',
            width: '100%',
            background: (theme) => {
                return shouldApplyVDKGradient
                    ? theme.palette.primary.gradient?.main ||
                        'linear-gradient(135deg, #00244D 0%, #3192D0 100%)'
                    : '#000000'; // Pure black for companies with custom colors
            },
            overflow: 'hidden'
        },
        layoutMainFull: {
            display: 'flex',
            flexDirection: 'column',
            paddingTop: `${isMobileIpadNavigation ? 0 : spaceAboveHeader}px`,
            width: '100%',
            height: '100%',
            minWidth: 0
        }
    };
};
export default useLayoutStyles;
